  // Get references to the relevant elements
const quantityInput = document.getElementById('quantityInput');
const btnMinus = document.getElementById('btn-minus');
const btnPlus = document.getElementById('btn-plus');
const lengthInput = document.getElementById('length_needed');
const widthInput = document.getElementById('width_needed');
const areaInput = document.getElementById('actual_area');
const packsNeededSpan = document.getElementById('packs_needed');
const calcPriceSpan = document.getElementById('calc-price');
const coverSpan = document.getElementById('cover');
const dataCoverageElement = document.getElementById('data-coverage');

// Store the original cover value
let originalCover = parseFloat(coverSpan.textContent);

// Flag to track whether quantity input value was changed programmatically
let quantityChangedProgrammatically = false;
let initialPrice = parseFloat(calcPriceSpan.textContent.replace(/[^\d.]/g, '')); // Store the initial price

// Add event listeners for length and width inputs
lengthInput.addEventListener('input', () => {
  validateNumberInput(lengthInput);
  updateAreaAndPacks();
});
widthInput.addEventListener('input', () => {
  validateNumberInput(widthInput);
  updateAreaAndPacks();
});

// Function to validate and format input as a number with up to 2 decimal places
function validateNumberInput(input) {
  let value = input.value.replace(/[^0-9.]/g, '');
  const parts = value.split('.');
  if (parts.length > 2) parts.length = 2;
  input.value = parts.join('.');
}

// Add event listener to validate quantity input
quantityInput.addEventListener('input', () => {
  validateNumberInput(quantityInput);
  quantityChangedProgrammatically = false;
  resetLengthWidthAndAreaIfNecessary();
  updatePacksNeeded();
  updateCoverFromQuantity();
});

function resetLengthWidthAndAreaIfNecessary() {
  if (!quantityChangedProgrammatically && (quantityInput.value === '' || quantityInput.value === '1')) {
    lengthInput.value = '';
    widthInput.value = '';
    areaInput.value = '';
  }
}

function getCoverageValue() {
  return parseFloat(dataCoverageElement.getAttribute('data-coverage'));
}

function updateAreaAndPacks() {
  const lengthValue = parseFloat(lengthInput.value);
  const widthValue = parseFloat(widthInput.value);

  if (!isNaN(lengthValue) && !isNaN(widthValue)) {
    const area = lengthValue * widthValue;
    areaInput.value = area.toFixed(2);
    const coverageValue = getCoverageValue();

    if (!isNaN(coverageValue) && coverageValue !== 0) {
      const packsNeeded = Math.ceil(area / coverageValue);
      packsNeededSpan.textContent = packsNeeded;
      quantityInput.value = packsNeeded;
    } else {
      packsNeededSpan.textContent = '1';
      quantityInput.value = '1';
    }
    coverSpan.textContent = area.toFixed(2);
  } else {
    areaInput.value = '';
    packsNeededSpan.textContent = '1';
    quantityInput.value = '1';
    coverSpan.textContent = '0.00';
  }
  updateCalculatedPrice();
}

function updatePacksNeeded() {
  if (!quantityChangedProgrammatically) {
    packsNeededSpan.textContent = quantityInput.value === '0' || quantityInput.value === '' ? '1' : quantityInput.value;
    updateCalculatedPrice();
    updateCoverFromQuantity();
  }
}

function updateCalculatedPrice() {
  const packsNeeded = parseInt(packsNeededSpan.textContent);
  const calculatedPrice = initialPrice * packsNeeded;
  calcPriceSpan.textContent = calculatedPrice.toFixed(2);
}

function updateCover() {
  const areaValue = parseFloat(areaInput.value);
  coverSpan.textContent = (!isNaN(areaValue) && areaValue !== 0) ? areaValue.toFixed(2) : '0.00';
}

function updateCoverFromQuantity() {
  const quantityValue = parseInt(quantityInput.value);
  const coverageValue = getCoverageValue();
  if (!isNaN(quantityValue) && !isNaN(coverageValue) && coverageValue !== 0) {
    const area = quantityValue * coverageValue;
    coverSpan.textContent = area.toFixed(2);
  } else {
    coverSpan.textContent = '0.00';
  }
}

quantityInput.addEventListener('change', () => {
  quantityChangedProgrammatically = true;
});

btnMinus.addEventListener('click', () => {
  if (parseInt(quantityInput.value) > parseInt(quantityInput.min)) {
    lengthInput.value = '';
    widthInput.value = '';
    areaInput.value = '';
    quantityInput.dispatchEvent(new Event('input'));
  }
});

btnPlus.addEventListener('click', () => {
  if (parseInt(quantityInput.value) < parseInt(quantityInput.max) || !quantityInput.max) {
    lengthInput.value = '';
    widthInput.value = '';
    areaInput.value = '';
    quantityInput.dispatchEvent(new Event('input'));
  }
});

// Initial call to set up the initial state
quantityInput.value = '1';
lengthInput.value = '';
widthInput.value = '';
areaInput.value = '';

// Ensure initial price display is correct
calcPriceSpan.textContent = initialPrice.toFixed(2);